import React, { useState } from 'react';
import axios from '../api/axiosConfig';
import './Modal.css';

const ConfirmarPreasignacionModal = ({ isOpen, onClose, tramite, onSuccess }) => {
  const [cuplNumber, setCuplNumber] = useState('');
  const [pdfFile, setPdfFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  if (!isOpen || !tramite) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      // 1. Confirmar la preasignación
      await axios.put(`/api/tramites/${tramite.id}/estado`, { estado: 'pre_asignado' });

      // 2. Si se adjuntó un archivo CUPL, cargarlo
      if (pdfFile) {
        const formData = new FormData();
        formData.append('cupl_number', cuplNumber);
        formData.append('cupl_pdf', pdfFile);
        formData.append('tramite_id', tramite.id);

        await axios.post(`/api/tramites/${tramite.id}/cargar-cupl`, formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        });
        
      }

      let resumen = pdfFile ? '✅ Trámite preasignado y CUPL cargado exitosamente.' : '✅ Trámite preasignado exitosamente.';
      resumen += `\n\n🔎 A las 6:00 p. m. el sistema verificará en RUNT que la placa esté pre-asignada. Si no aparece, el trámite volverá a espera de pre-asignación y se le avisará.`;
      alert(resumen);

      onSuccess();
      onClose();
      setCuplNumber('');
      setPdfFile(null);
    } catch (err) {
      console.error('Error en preasignación/carga CUPL:', err);
      const msg = err.response?.data?.message || 'Error durante el proceso';
      setError(msg);
      alert('❌ Error: ' + msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content" style={{ maxWidth: '500px' }}>
        <div className="modal-header">
          <h3>✅ Confirmar Pre-asignación - Trámite #{tramite.id}</h3>
          <button className="close-btn" onClick={onClose}>&times;</button>
        </div>

        <form onSubmit={handleSubmit} className="modal-form" style={{ padding: '20px 0' }}>
          {error && <div className="error-banner" style={{ marginBottom: '15px' }}>{error}</div>}
          
          <div style={{ marginBottom: '20px', fontSize: '14px', color: '#475569', lineHeight: '1.5' }}>
            ¿Está seguro de confirmar la pre-asignación de placa para este trámite?
          </div>

          <div className="info-card" style={{ background: '#f8fafc', padding: '15px', borderRadius: '10px', marginBottom: '20px', border: '1px solid #e2e8f0' }}>
            <p style={{ margin: '0 0 5px 0', fontSize: '14px' }}><strong>Propietario:</strong> {tramite.datos_adicionales?.propietario}</p>
            <p style={{ margin: '0 0 5px 0', fontSize: '14px' }}><strong>Placa:</strong> <span className="plate-badge-sm">{tramite.datos_adicionales?.placa_referencia || 'N/A'}</span></p>
            <p style={{ margin: '0', fontSize: '14px' }}><strong>Tránsito:</strong> <span style={{ background: '#e0e7ff', color: '#3730a3', padding: '2px 10px', borderRadius: '6px', fontWeight: '600', fontSize: '13px' }}>{tramite.transito_name || 'N/A'}</span></p>
          </div>

          <hr style={{ border: '0', borderTop: '1px solid #e2e8f0', margin: '20px 0' }} />

          <div style={{ fontWeight: '700', fontSize: '13px', color: '#1e293b', marginBottom: '15px', display: 'flex', alignItems: 'center', gap: '6px' }}>
            📄 CARGAR CUPL DE UNA VEZ (OPCIONAL)
          </div>

          <div className="form-group">
            <label>Número de CUPL: <span style={{ color: '#94a3b8', fontWeight: '400', fontSize: '12px' }}>(Opcional)</span></label>
            <input 
              type="text" 
              value={cuplNumber} 
              onChange={(e) => setCuplNumber(e.target.value)} 
              placeholder="Dejar vacío para extraer del PDF automáticamente"
              style={{ padding: '12px', borderRadius: '8px', border: '1px solid #cbd5e1' }}
              disabled={loading}
            />
          </div>

          <div className="form-group" style={{ marginTop: '15px' }}>
            <label>Archivo PDF del CUPL:</label>
            <input 
              type="file" 
              accept=".pdf" 
              onChange={(e) => setPdfFile(e.target.files[0])} 
              style={{ padding: '10px', background: '#f1f5f9', borderRadius: '8px', border: '1px dashed #cbd5e1', width: '100%' }}
              disabled={loading}
            />
            <small style={{ color: '#64748b', display: 'block', marginTop: '5px' }}>
              Si selecciona un archivo, el CUPL se cargará y asociará al trámite inmediatamente.
            </small>
          </div>

          <div className="modal-actions" style={{ marginTop: '30px' }}>
            <button type="button" className="btn-secondary" onClick={onClose} disabled={loading}>
              Cancelar
            </button>
            <button type="submit" className="btn-primary" disabled={loading} style={{ background: 'var(--success-color, #16a34a)' }}>
              {loading ? '⏳ Procesando...' : '✅ Pre-asignar'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ConfirmarPreasignacionModal;